module.exports = __webpack_public_path__ + "static/a-078141c9cba709c66144a69d0f4f638f.jpg";